<div class="card card-redlaboral m-4">
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-12">
        <button type="button" class="btn btn-outline-primary" (click)="goBack()">
          <i class="fa-solid fa-arrow-left me-2"></i> Volver al listado
        </button>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <h4 class="mt-0 mb-3 text-primary">
          <i class="fa-regular fa-building me-2"></i>
          Detalles de la Empresa
        </h4>
      </div>
    </div>

    <!-- Sección de carga -->
    <div *ngIf="isLoading" class="text-center my-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p class="mt-2">Cargando información de la empresa...</p>
    </div>

    <!-- Sección cuando no se ha encontrado la información de la empresa -->
    <div *ngIf="!isLoading && !isFound" class="alert alert-warning text-center" role="alert">
      No se ha encontrado la información de la empresa solicitada.
    </div>

    <!-- Sección principal cuando se encontró la data -->
    <div *ngIf="!isLoading && isFound">
      <app-register-form-company
        [showSaveButton]="false"
        [showSaveRegister]="false"
        [isEditMode]="false"
        [isViewMode]="true"
        [companyData]="company"
        [companyAddresses]="addresses">
      </app-register-form-company>
    </div>
  </div>
</div>
